import React from "react";
import { People } from "pages";

const PeopeRoute = () => {
  return (
    <>
      <People />
    </>
  );
};

export default PeopeRoute;
